import type { FacetValue } from "../facet-value";
import type { FilterMode } from "../filter/type.ts";
import type { FacetLocation } from "./type.ts";
import { isActive } from "../../toggle/Toggle.ts";

type ArrayFunction<T, U> = (value: T, index: number, array: T[]) => U;
type ArrayUnaryFunction<T> = ArrayFunction<T, T>;
type ArrayPredicate<T> = (value: T, index: number, array: T[]) => boolean;

export const not =
  <T>(predicate: ArrayPredicate<T>): ArrayPredicate<T> =>
  (...args) =>
    !predicate(...args);

/*                                     */

export const isSelected: ArrayPredicate<FacetValue> = (value: FacetValue) => value.checked;
export const isPopular: ArrayPredicate<FacetValue> = (value: FacetValue) => value.popular;
export const isInDenseMode: ArrayPredicate<FacetValue> = (value: FacetValue) => Boolean(value.inDenseMode);
export const isNba: ArrayPredicate<FacetValue> = (value: FacetValue) => value.nba ?? false;
export const isSaved: ArrayPredicate<FacetValue> = (value: FacetValue) => value.saved ?? false;
export const isNotSelected: ArrayPredicate<FacetValue> = not(isSelected);
export const isNotPopular: ArrayPredicate<FacetValue> = not(isPopular);
export const isNotInDenseMode: ArrayPredicate<FacetValue> = not(isInDenseMode);
export const isNotSaved: ArrayPredicate<FacetValue> = not(isSaved);

export const addNameAndFeatureTracking =
  (
    parentId: string,
    name: string,
    offset?: number,
    mode?: FilterMode,
    facetLocation?: FacetLocation | undefined | null,
  ): ArrayUnaryFunction<FacetValue> =>
  (facetValue: FacetValue, index: number) => {
    if (!facetValue) {
      return facetValue;
    }
    const { featureTracking, ...rest } = facetValue;
    const labels = isActive("HEUREKA_2047_ADJUST_TRACKING")
      ? {
          ...(featureTracking?.labels || {}),
          ...(facetLocation != null && {
            san_FacetLocation: [facetLocation],
          }),
        }
      : {
          ...(featureTracking?.labels || {}),
        };
    return {
      name,
      ...rest,
      ...(featureTracking && {
        featureTracking: {
          parentId,
          ...(offset !== undefined && { position: `${index + offset}` }),
          method: rest.popular && (!mode || mode !== "sheetSecondLevel") ? "popular" : undefined,
          ...featureTracking,
          labels: labels,
        },
      }),
    };
  };
